<div>
    <div class="label">
        <slot name="label" />
    </div>
    <div class="settings-section">
        <div class="content">
            <slot name="content" />
        </div>
    </div>
</div>

<style>
    .settings-section {
        background-color: var(--section-background);
        border-radius: 6px;
        padding: 12px 15px;
    }
    .settings-section :global([slot="content"]) {
        display: flex;
        flex-direction: column;
        row-gap: 6px;
    }

    .label {
        margin-top: 25px;
        margin-bottom: 15px;
        font-size: 18px;
        font-weight: 300;
        line-height: 21.6px;
    }

</style>